import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogues } from "../../store/catalogue/actions";
export var useCataloguesGetAll = function (trigger, type, clientId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseCatalogues: (_a = state.Catalogues.responseCatalogues) === null || _a === void 0 ? void 0 : _a.data,
            errorCatalogues: state.Catalogues.errorCatalogues,
            loadingCatalogues: state.Catalogues.loadingCatalogues,
        });
    }), responseCatalogues = _d.responseCatalogues, errorCatalogues = _d.errorCatalogues, loadingCatalogues = _d.loadingCatalogues;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogues({
                enable: enable,
                page: page,
                limit: limit,
                type: type,
                clientId: clientId,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseCatalogues: responseCatalogues,
        errorCatalogues: errorCatalogues,
        loadingCatalogues: loadingCatalogues,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
